import { Component, Input, OnInit } from '@angular/core';
import { Review } from '../../../../models/review.model';
import { Utils } from '../../../../utils/utils';

@Component({
    selector: 'app-review',
    templateUrl: './review.component.html',
    styleUrls: ['./review.component.css'],
    standalone: false
})
export class ReviewComponent implements OnInit {
  protected Utils = Utils;
  @Input() review?: Review;
  @Input() small: boolean = false;
  @Input() showDate: boolean = true;
  @Input() fakeLink: boolean = false;
  @Input() showFullReview = false;

  constructor() { }

  ngOnInit() { }
}
